class InsetCalculator {
    left;
    top;
    right;
    bottom;
    outerWidth;
    outerHeight;
    constructor(elem) {
        const parent = InsetCalculator.getParentSize(elem);
        this.outerWidth = parent.width;
        this.outerHeight = parent.height;
        this.left = elem.offsetLeft;
        this.top = elem.offsetTop;
        this.right = this.outerWidth - (this.left + elem.offsetWidth);
        this.bottom = this.outerHeight - (this.top + elem.offsetHeight);
    }
    get width() {
        return this.outerWidth - (this.right + this.left);
    }
    get height() {
        return this.outerHeight - (this.bottom + this.top);
    }
    expand(inset) {
        this.left += inset.left;
        this.top += inset.top;
        this.right += inset.right;
        this.bottom += inset.bottom;
        this.outerWidth = inset.outerWidth;
        this.outerHeight = inset.outerHeight;
        return this.toObject();
    }
    toObject() {
        return {
            left: this.left,
            top: this.top,
            right: this.right,
            bottom: this.bottom,
            width: this.width,
            height: this.height,
            outerWidth: this.outerWidth,
            outerHeight: this.outerHeight,
        };
    }
    static getParentSize(elem) {
        return {
            width: elem.parentElement?.offsetWidth || window.innerWidth,
            height: elem.parentElement?.offsetHeight || window.innerHeight,
        };
    }
}
export default function getElementInset(elem, depth = 0) {
    const inset = new InsetCalculator(elem);
    return depth > 0 && elem.parentElement
        ? inset.expand(getElementInset(elem.parentElement, depth - 1))
        : inset.toObject();
}
